function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.74736 6.5H0.522461L6.79234 0.5V5.5C6.79234 5.76522 6.68229 6.01957 6.48632 6.20711C6.29035 6.39464 6.0245 6.5 5.74736 6.5Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.3771 14.56V22.5C20.3771 22.7652 20.267 23.0196 20.0711 23.2071C19.8751 23.3946 19.6092 23.5 19.3321 23.5H1.56744C1.29029 23.5 1.02445 23.3946 0.82848 23.2071C0.632508 23.0196 0.522461 22.7652 0.522461 22.5V8.56",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.88281 0.5H19.3326C19.6098 0.5 19.8756 0.605356 20.0716 0.792892C20.2675 0.980429 20.3776 1.23478 20.3776 1.5V6.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6158 18.75L9.55078 20.51L11.3899 16.62L20.2618 8.14001L22.4772 10.26L13.6158 18.75Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7424 11.92L18.5166 9.79999",
  stroke: "currentColor",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.606 18.75L11.3906 16.62",
  stroke: "currentColor",
  strokeLinejoin: "round"
});

var SvgPlans = function SvgPlans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plans.dccb4776.svg";
export { ForwardRef as ReactComponent };